<template lang="slm">
section
  .container
    .columns
      .column.is-8.is-offset-2
        .DonateBox
          h2 {{text}}
          p.lead {{sub}}
          form.Form(action="https://peaceful-cliffs-83180.herokuapp.com/api/v1/doner" method="POST" id="stripe-form" novalidate)
            button.Button.is-red.amount-button(data-amount="10000" type="button" @click="buttonClick(100)") 100,-
            button.Button.is-red.amount-button(data-amount="25000" type="button" @click="buttonClick(250)") 250,-
            button.Button.is-red.amount-button(data-amount="50000" type="button" @click="buttonClick(500)") 500,-
            button.Button.is-red.amount-button(type="button" @click="buttonClick(0)") Annet beløp
            transition name="fade"
              .DonateBox-formDetails(v-if="showForm" :class="formDetails")
                input type="hidden" name="stripeToken" v-model="formData.stripeToken"
                input type="hidden" name="stripeAmount" v-model="formData.stripeAmount"
                input type="hidden" name="userEmail" v-model="formData.userEmail"
                hr
                .control.is-grouped.Form-control
                  p.control.Form-control
                    label.label Beløp
                    input#AmountInput(type='number' class='input is-large' name='Beløp' v-validate="'required'" v-model="formData.stripeAmount")
                    span.form-error v-show="errors.has('Beløp')" {{ errors.first('Beløp') }}

                  p.control.Form-control.is-expanded
                    label.label Fullt navn
                    input(type='text' class='input is-large' name='Navn' v-validate="'required'" v-model="formData.navn")
                    span.form-error v-show="errors.has('Navn')" {{ errors.first('Navn') }}

                .control.is-grouped.Form-control
                  p.control.is-expanded.Form-control
                    label.label(for='email') E-post
                    input(type='email' name='Epost' id='email' class='input is-large'  v-validate="'required|email'" v-model="formData.userEmail")
                    span.form-error v-show="errors.has('Epost')" {{ errors.first('Epost') }}

                  p.control.Form-control
                    label.label Postnummer
                    input(type='number' max='9999' class='input is-large' name='Postnummer' v-validate="'required'" v-model="formData.zip")
                      span.form-error v-show="errors.has('Postnummer')" {{ errors.first('Postnummer') }}

                .control.Form-control
                  p.control
                    label.label Kortinformasjon
                    card class='stripe-card field' :class='{ cardComplete }' :stripe="key" :options="options" @change='cardUpdate'
                    p.card-error v-show="cardError" {{cardError}}

                p.control
                  button.button.Button.is-primary.is-marginless.send-button type="button" @click="pay" v-bind:class="{'is-loading' : formIsLoading}" :disabled='!cardComplete' Betal

</template>

<script>
import { stripeKey, stripeOptions } from '@/stripeConfig.json'
import { Card, createToken } from 'vue-stripe-elements'
import norwegian from 'vee-validate/dist/locale/nb_NO'
require('es6-promise').polyfill()
require('isomorphic-fetch')

export default {
  components: { Card },
  created () {
    this.$http.options.xhr = {withCredentials: true}
    this.$http.options = {credentials: true}
    this.$http.options.emulateJSON = true
    this.$validator.updateDictionary({
      nb_NO: {
        messages: norwegian.messages
      }
    })
    this.$validator.setLocale('nb_NO')
  },
  data () {
    return {
      key: stripeKey,
      options: stripeOptions,
      cardComplete: false,
      showForm: false,
      cardError: null,
      formIsValid: false,
      formIsLoading: false,
      formData: {
        stripeAmount: 0,
        userEmail: '',
        zip: '',
        navn: '',
        stripeToken: ''
      },
      formDetails: {
        display: 'none'
      }
    }
  },
  props: ['text', 'sub'],
  methods: {
    pay () {
      this.formIsLoading = true
      createToken({
        name: this.formData.navn,
        email: this.formData.userEmail,
        address_zip: this.formData.zip
      })
        .then(data => {
          console.log(data)
          if (data.error) {
            this.formIsLoading = false
            this.formIsValid = false
            this.cardError = data.error.message
          } else {
            this.formData.stripeAmount = this.formData.stripeAmount * 100
            this.formData.stripeToken = data.token.id
            let submitData = new FormData()
            submitData.append('userEmail', this.formData.userEmail)
            submitData.append('stripeToken', this.formData.stripeToken)
            submitData.append('navn', this.formData.navn)
            submitData.append('stripeAmount', this.formData.stripeAmount)
            console.log(submitData)
            fetch('https://peaceful-cliffs-83180.herokuapp.com/doner', {
              body: submitData,
              method: 'POST'
            }).then((result) => {
              console.log(result)
            })
          }
        })
    },
    cardUpdate (event) {
      console.log(event)
      if (event.error) {
        this.cardError = event.error.message
      } else {
        this.cardError = null
        this.validateForm()
        if (event.complete && this.formIsValid) {
          this.cardComplete = true
        } else {
          this.cardComplete = false
        }
      }
    },
    buttonClick (amount) {
      this.showForm = true
      this.formDetails.display = 'block'
      this.formData.stripeAmount = amount
    },
    validateForm () {
      this.$validator.validateAll().then(() => {
        this.formIsValid = true
      }).catch(() => {
        this.formIsValid = false
      })
    }
  }
}
</script>

<style lang="css">
.form-error {
  font-size: 11px;
  color: red;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/Donate.vue